'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Chart = require('./Chart.css');

var _Chart2 = _interopRequireDefault(_Chart);

var _reactChartjs = require('react-chartjs');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Row, Col} from 'react-flexbox-grid'

var chartOptions = {
  animation: false,
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  // animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  // tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
  tooltipTemplate: '<%=label %>',
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>"
};

var Chart = (_dec = (0, _reactCssModules2.default)(_Chart2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);
    return (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var chartData = this.props.chartData;
      var invested = this.props.invested;
      var currency = this.props.currency;
      var chartMessage = this.props.chartMessage || 'in weapon investments';

      return _react2.default.createElement(
        'div',
        { styleName: 'chart' },
        _react2.default.createElement(_reactChartjs.Doughnut, {
          data: chartData,
          options: chartOptions,
          width: '300',
          height: '300'
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'chart-details' },
          _react2.default.createElement(
            'div',
            { styleName: 'chart-assets' },
            _format2.default.money(invested, true, currency)
          ),
          _react2.default.createElement(
            'div',
            null,
            chartMessage
          )
        )
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  currency: _react.PropTypes.string.isRequired,
  invested: _react.PropTypes.number.isRequired,
  chartData: _react.PropTypes.array.isRequired,
  chartMessage: _react.PropTypes.string
}, _temp)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1272
// module chunks = 0